import React from 'react';
import { createRoot } from 'react-dom/client';

import * as serviceWorker from './serviceWorker';
import AppWrapper from './components/AppWrapper/AppWrapper';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<AppWrapper />);

serviceWorker.unregister();
